import React from "react";
import { useDispatch } from "react-redux";
import { updateFile, changeText } from "../actions/fileActions";
import { ConvertTagsToHtml } from "../helpers/TagHelper";
const Row = ({ row }) => {
  // const{uploadedFile} = useSelector((state) => state.file)
  const dispatch = useDispatch();

  let html = ConvertTagsToHtml(row.segmentText);
  let div = document.createElement("div");
  div.innerHTML = html.ResultHTML.trim();

  return (
    
      <div className="card mb-1">
        <div className="translation-line row mx-1">
          <div className="col-5 text-start align-self-center">
            <p className="prop-name ">{row.filterSpecificNotes}</p>
          </div>
          <div className="col-7 text-start">
            <p className="prop-content" dangerouslySetInnerHTML={{__html:html.ResultHTML}}></p>
          </div>
        </div>
      </div>
   
  );
};

export default Row;
